import React, {FC} from 'react';
import {connect} from "react-redux";
import {setTobaccoIndex} from "../../modules/Main";
import WrapperPreloader from "../../components/WrapperPreloader";
import CompilationsTitle from '../../components/Main/CompilationsTitle';
import MixesList from '../../components/MixesList';
import {IMix} from "../../constants/types";

interface IListCompilationsPage {
    mixCompilation: Array<IMix>,
    tobaccoIndex: number,
    isLoading: boolean,
    currentCompilation: Array<string>,
    setTobaccoIndex: any
}

const ListCompilationsPage: FC<IListCompilationsPage> = ({
                                                   mixCompilation,
                                                   setTobaccoIndex,
                                                   isLoading,
                                                   currentCompilation
                                               }) => {

    return (
        <WrapperPreloader isLoading={isLoading}>
            <div className="collections">
                <CompilationsTitle
                    title={currentCompilation[0]}
                    imageUrl={currentCompilation[1]}
                />
                <MixesList
                    pathUrl="/main/compilation/mix/"
                    setTobaccoIndex={setTobaccoIndex}
                    mixes={mixCompilation}
                />
            </div>
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.main.isLoading,
    mixCompilation: state.main.mixCompilation,
    tobaccoIndex: state.main.clickedTobaccoIndex,
    currentCompilation: state.main.currentCompilation,
});

const mapDispatchToProps = (dispatch: any) => ({
    setTobaccoIndex: (id: number) => dispatch((setTobaccoIndex(id))),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ListCompilationsPage);

